import { useEffect } from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import Constants from 'src/core/utils/Constants';
import { useAuthStore } from 'src/domain/stores/useAuthStore';
import { useMessagesStore } from 'src/domain/stores/useMessagesStore';
import { useServicesStore } from 'src/domain/stores/useServicesStore';
import MainStackNavigator from 'src/presentation/navigation/navigators/MainStackNavigator';
import AuthNavigator from 'src/presentation/navigation/navigators/AuthNavigator';
import type { RootNavigation } from 'src/presentation/navigation/types/NavigationTypes';
import type ApiRequestError from 'src/core/models/api/ApiRequestError';
import { useActiveLanguage } from 'src/presentation/hooks/useActiveLanguage';

const RootStack = createStackNavigator<RootNavigation>();

export default function RootNavigator() {
	useActiveLanguage();

	const { isAuthenticated } = useAuthStore();
	const { getApiMessages } = useMessagesStore();
	const { captureEvent } = useServicesStore();

	useEffect(() => {
		if (isAuthenticated) {
			getApiMessages().catch((error: ApiRequestError) => {
				captureEvent({ message: 'Fetching the messages after sign in failed.', extra: { error } });
			});
		}
	}, [captureEvent, getApiMessages, isAuthenticated]);

	return (
		<RootStack.Navigator screenOptions={{ headerShown: false }}>
			{!isAuthenticated ? (
				<RootStack.Screen component={AuthNavigator} name={Constants.navigatorAuth} />
			) : (
				<RootStack.Screen component={MainStackNavigator} name={Constants.navigatorMain} />
			)}
		</RootStack.Navigator>
	);
}
